<template>
    <div class="border-gray-800 border-t-4 flex items-end mr-4">
        <div class="">
            <div class="text-xs text-gray-500">Price excl.</div>
            <div class="inline-block text-xl sm:text-2xl font-bold">
                <span class="text-gray-500 mr-1">{{ settings.currency }}</span>
                <span>{{
                    separator(this.$store.getters['prices/totalPrice'](price))
                }}</span>
            </div>
        </div>

        <div v-if="price.tax.rate > 0" class="ml-4 sm:ml-8">
            <div class="text-xs text-gray-500">Price incl.</div>
            <div class="inline-block text-xl sm:text-2xl font-bold">
                <span class="text-gray-500 mr-1">{{ settings.currency }}</span>
                <span>{{
                    separator(
                        this.$store.getters['prices/totalPriceIncTax'](price)
                    )
                }}</span>
            </div>
        </div>

        <div class="inline-block ml-2">
            <button
                @click="openModal"
                aria-label="Show options for price total"
                class="group relative w-9 rounded-full text-gray-800 hover:text-gray-500 focus:text-gray-500 p-2"
            >
                <IconSettingsSliders></IconSettingsSliders>
                <div class="tooltip tooltip-left">
                    Price Headline Price options
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import { separator } from '@/helpers'
import { mapState } from 'vuex'
import IconSettingsSliders from '@/components/icons/IconSettingsSliders'

export default {
    name: 'PriceTotal',
    components: {
        IconSettingsSliders,
    },
    data() {
        return {
            separator,
        }
    },
    computed: {
        ...mapState('settings', {
            settings: 'settings',
        }),
        ...mapState('prices', {
            price: 'price',
        }),
    },
    methods: {
        openModal() {
            this.$root.$emit('show-headline-price-modal')
        },
    },
}
</script>
